/**
 * created by tianruojun
 * 基础信息
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    message,
    Input,
    Checkbox,
    Button,
    Upload,
    Icon,
    Select,
    Row,
    Col,
    Table,
    Progress,
    Modal,
    Slider,
    Empty
} from 'antd'
import SelectSource from "./selectSource/SelectSource"
import UploadFiles from "./uploadFiles/UploadFiles"
import './EditorInformation.css'
import {Scrollbars} from 'react-custom-scrollbars';
import BaseComponent from "../../../base/BaseComponent";
import {AUDIO_TYPE, FILE_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../constants";
import fontBold from './image/fontBold.png';
import fontTilt from './image/fontTilt.png';
import titlePic from './image/titlePic.png';
import clearFontStyle from './image/clearFontStyle.png';
import ChunkUpload from "../../../components/upload/ChunkUpload";
import UploadWall from "../../../components/upload/UploadWall";
import SketchColor from "./sketchColor/sketchColor";
import fontColorA from "./image/fontColorA.png";
import SimpleFloatTool from "../floatTool/simpleFloatTool";
import $Jq from 'jquery'
import {getInfoFromLocalStorage} from "../../../actions";
import playPic from "../../mediaRelease/image/sanjiaoxing.png";
import moment from "moment";
import VideoCapture from "./editContentChoose/VideoCapture";
import ImgChoose from "./editContentChoose/ImgChoose";
import Editors from'../../components/editor/Editors'
import {base64Encode, downloadImg, uuid} from "../../../utils";
import {removeContentSecurity} from "../floatTool/securityCheck";
import {buildInsertPicHtml} from "../toolsSpace/tools/pictureTool/pictureTool";
import {buildInsertVideoHtml} from "../toolsSpace/tools/videoTool/videoTool";
import videoNull from "./toolbarAmendModal/img/videoNull.png";
import {DetailDialog as Picture} from "../../resource/view/dialog/picture/picture";

let informationConfig;
let formItemSizeConfig;
const plainOptions = ['内容标题', '短标题', '副标题', '引题'];
const {TextArea} = Input;
let fileType = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'rm', 'rmvb', 'wmv', 'avi', 'asf', 'mpg', 'mpeg', 'flv', 'mp4', 'mov', 'mp3', 'mp2', 'wav', 'mid', 'midi', 'ra', 'doc', 'docx', 'ppt', 'pptx', 'pps', 'ppsx', 'xls', 'xlsx', 'pdf', 'eot', 'woff', 'svg', 'ttf', 'otf', 'zip', 'rar', 'swf', 'wps', 'dps', 'et', 'apk'];
fileType = [...fileType, ...fileType.toUpperCase()]

const titleSetting = {
    titleKey: 'title',//数据保存标题key
    titleName: '标题',//标题名称
    titlePlaceholder: '请输入标题',//标题的提示
    titleIsRequest: true,//是否必输项，
    titleMaxlength: 255,//最大输入长度,
    titleCheckMessage: '请输入标题',
    titleDisable: false,
};

let informationSetting = {
    //标题样式配置项
    titleStyleKey:'titleStyle',
    //内容标题置项
    wbcontenttitleKey: 'wbcontenttitle',//内容标题数据保存标题key
    wbcontenttitleName: '内容标题',//内容标题标题名称
    wbcontenttitlePlaceholder: '请输入内容标题',//内容标题的提示
    wbcontenttitleIsRequest: false,//是否必输项，
    wbcontenttitleMaxlength: 50,//最大输入长度,
    wbcontenttitleCheckMessage: '请输入内容标题',
    wbcontenttitleDisable: true,//false  不可输入
    //短标题置项
    headlinesKey: 'wbshorttitle',//列表标题数据保存标题key
    headlinesName: '短标题',//列表标题标题名称
    headlinesPlaceholder: '请输入短标题',//列表标题的提示
    headlinesIsRequest: false,//是否必输项，
    headlinesMaxlength: 255,//最大输入长度,
    headlinesCheckMessage: '请输入短标题',
    headlinesDisable: false,//false  不可输入
//副标题配置项
    ftitleKey: 'wbsubtitle',//数据保存标题key
    ftitleName: '副标题',//标题名称
    ftitlePlaceholder: '请输入标题',//标题的提示
    ftitleIsRequest: false,//是否必输项，
    ftitleMaxlength: 255,//最大输入长度,
    ftitleCheckMessage: '请输入副标题',
    ftitleDisable: false,//false  不可输入
// 引题配置项
    eyebrowKey: 'wbforwardtitle',//数据保存标题key
    eyebrowName: '引题',//引题名称
    eyebrowPlaceholder: '请输入引题',//引题的提示
    eyebrowIsRequest: false,//是否必输项，
    eyebrowMaxlength: 255,//最大输入长度,
    eyebrowCheckMessage: '请输入引题',
    eyebrowDisable: false,//false  不可输入


    //以上四个要放到可空字段
    variableFieldsKey:'variableFields',

// 作者配置项
    authorKey: 'authorFtitle',//数据保存标题key
    authorName: '作者',//作者名称
    authorPlaceholder: '请输入作者',//作者的提示
    authorIsRequest: true,//是否必输项，
    authorMaxlength: 10,//最大输入长度,
    authorCheckMessage: '请输入作者',
    authorDisable: false,//false  不可输入
// 作者电话配置项
    authorCallsKey: 'authorCallsFtitle',//数据保存标题key
    authorCallsName: '作者电话',//作者电话名称
    authorCallsPlaceholder: '请输入作者电话',//作者电话的提示
    authorCallsIsRequest: false,//是否必输项，
    authorCallsMaxlength: 20,//最大输入长度,
    authorCallsCheckMessage: '请输入作者电话',
    authorCallsDisable: false,//false  不可输入
// 所属部门配置项
    departmentKey: 'departmentFtitle',//数据保存标题key
    departmentName: '所属部门',//所属部门名称
    departmentPlaceholder: '请输入所属部门',//所属部门的提示
    departmentIsRequest: true,//是否必输项，
    departmentMaxlength: 20,//最大输入长度,
    departmentCheckMessage: '请输入所属部门',
    departmentDisable: false,//false  不可输入
// 摄影配置项
    photographyKey: 'photographyFtitle',//数据保存标题key
    photographyName: '摄影',//摄影名称
    photographyPlaceholder: '请输入摄影',//摄影的提示
    photographyIsRequest: false,//是否必输项，
    photographyMaxlength: 20,//最大输入长度,
    photographyMessage: '请输入摄影',
    photographyDisable: false,//false  不可输入
// 摄像配置项
    cameraKey: 'cameraFtitle',//数据保存标题key
    cameraName: '摄像',//摄像名称
    cameraPlaceholder: '请输入摄像',//摄像的提示
    cameraIsRequest: false,//是否必输项，
    cameraMaxlength: 20,//最大输入长度,
    cameraMessage: '请输入摄像',
    cameraDisable: false,//false  不可输入
// 编辑配置项
    compileKey: 'compileFtitle',//数据保存标题key
    compileName: '编辑',//编辑名称
    compilePlaceholder: '请输入编辑',//编辑的提示
    compileIsRequest: false,//是否必输项，
    compileMaxlength: 20,//最大输入长度,
    compileMessage: '请输入编辑',
    compileDisable: false,//false  不可输入
// 来源配置项
    sourceKey: 'sourceFtitle',//数据保存标题key
    sourceName: '来源',//来源名称
    sourcePlaceholder: '请选择来源',//来源的提示
    sourceIsRequest: true,//是否必输项，
    sourceMaxlength: 20,//最大输入长度,
    sourceMessage: '请选择来源',
    sourceDisable: false,//false  不可输入
// 跳转链接配置项
    mipLinkKey: 'mipLinkFtitle',//数据保存标题key
    mipLinkName: '跳转链接',//跳转链接名称
    mipLinkPlaceholder: '请输入跳转链接',//跳转链接的提示
    mipLinkRequest: false,//是否必输项，
    mipLinkMaxlength: 255,//最大输入长度,
    mipLinkMessage: '请输入跳转链接',
    mipLinkDisable: false,//false  不可输入
// 关键字配置项
    keywordKey: 'keywordFtitle',//数据保存标题key
    keywordName: '关键字',//关键字名称
    keywordPlaceholder: '请输入关键字',//关键字的提示
    keywordRequest: true,//是否必输项，
    keywordMaxlength: 20,//最大输入长度,
    keywordMessage: '请输入关键字',
    keywordDisable: false,//false  不可输入
// 标签配置项
    labelKey: 'label',//数据保存标题key
    labelName: '标签',//标签名称
    labelPlaceholder: '请输入标签',//标签的提示
    labelRequest: false,//是否必输项，
    labelMaxlength: 20,//最大输入长度,
    labelMessage: '请输入标签',
    labelDisable: false,//false  不可输入
// 内容摘要配置项
    synopsisKey: 'synopsisFtitle',//数据保存标题key
    synopsisName: '内容摘要',//内容摘要名称
    synopsisPlaceholder: '请输入内容摘要',//内容摘要的提示
    synopsisRequest: false,//是否必输项，
    synopsisMaxlength: 30,//最大输入长度,
    synopsisMessage: '请输入内容摘要',
    synopsisDisable: false,//false  不可输入
//上传文件配置项
    uploadName: '' +
        '附件',//上传文件
};
// 站群字段配置项
const columnExtendFieldSetting = {
    variableFieldsKey: "wbextends", // 后端需要的外包装
    label: "fieldDispname", // 字段名
    key: "fieldName", // 字段key
    type: "fieldHtmltype", // 输入框类型
    selectvalue: "selectvalue", // 下拉框可选项
    required: "required", // 必填判断
    disabled: "disabled", // 禁用判断
};
// 后端动态字段配置项
const regulation = {
    variableFieldsKey: "variableFields", // 后端需要的外包装
    // id
    id: 'id',
    // 输入框名字
    labelName: 'showName',
    // 字段key
    labelCode: 'field',
    // 字段类型
    labelType: 'fieldType',
    // 是否必填
    required: 'required',
    // 校验正则
    validateRules: 'regx',
    // 当前字段排序
    sort: 'sort',
    // 类名字段
    className: 'className',
    // 是否只读
    disabled: 'disabled',
};

function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
}

// function getBase64(file, callback) {
//     return new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.readAsDataURL(file);
//         reader.onload = () => resolve(reader.result);
//         reader.onerror = error => reject(error);
//     });
// }
export default class EditorInformation extends BaseComponent {
    static defaultProps = {
        contentText: '',//编辑器文字
    };
    static propTypes = {
        contentText: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state = {
            variableFieldsSetting: [],//后台返回动态表单配置项
            fileNumber: '',//上传个数
            keywordDefaultChecked: true,
            summaryDefaultChecked: true,
            synopsisDefaultChecked: true,
            visible: false,
            uploadVisible: false,
            // headlines: false,
            // subheading: false,
            // eyebrow: false,
            information: { // 表单数据
                title: '',//标题
                titlePic: '',
                attach: [],//附件
                variableFields: { // 可控字段
                    label: [],//标签
                    titleStyle: {},
                    author: window.currentUser.name?window.currentUser.name:"",
                    contact: window.currentUser.phone&& window.currentUser.phone!="null"?window.currentUser.phone:"",
                },
                wbextends: { // 站群字段

                },
            },// 表单固定参数
            dynamicParams: {},// 表单动态参数
            checkedTitleList: [],
            titleStatus: false,//标题的展开收起，false 收起
            title: '',//标题
            labelInputVal: "",
            fontTilt: false,//标题倾斜
            fontBold: false,//标题加粗
            fileList: [],//标题图
            titlePicVisible: false,//标题图弹窗
            contentVisible: false,//正文选择
            previewImage: '',
            hover: false,//悬浮时
            videoVisible: false,//视频截取弹窗
            imgAll: [],//内容全部图片
            videoAll: [],//内容全部视频
            currentCheckedPic: '',//选中图片
            currentCheckedVideo: "",//选中视频帧图片
            currentChecked: false,// 当前选中
            columnExtendField: [],// 站群扩展字段（配置参数）
            wbextends: {},// 站群扩展字段（参数）
            isUpDate:false,//强制更新编辑器内容，
            visibleValue:true,
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp'],
            checkedValue:false,//跳转链接
        }
    }

    componentWillMount() {
        informationConfig = this.props.informationConfig;
        formItemSizeConfig = this.props.formItemSizeConfig;
        this.getSysConfigGetValueByKey();
        this.getExtendsField();
        this.getColumnExtendField({
            treeId: this.props.dynamicParams.treeId,
            mediaId: this.props.dynamicParams.mediaId,
        });
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        informationConfig = nextProps.informationConfig;
        formItemSizeConfig = nextProps.formItemSizeConfig;
        if (this.props.contentText != nextProps.contentText) {
            this.setState({});
        }
        if(
            this.props.dynamicParams && nextProps.dynamicParams &&
            (this.props.dynamicParams.treeId != nextProps.dynamicParams.treeId || this.props.dynamicParams.mediaId != nextProps.dynamicParams.mediaId)
        ) {
            this.getColumnExtendField({
                treeId: nextProps.dynamicParams.treeId,
                mediaId: nextProps.dynamicParams.mediaId,
            });
        }
    }

    componentWillUnmount() {
    }

    // 获取配置项
    getSysConfigGetValueByKey = () => {
        informationSetting.wbcontenttitleMaxlength = this.sysConfigGetValueByKey("wbcontenttitle.maxlength", "1000")*1;
        let variableFieldsKey = regulation["variableFieldsKey"];
        this.state.information[variableFieldsKey]["autoExtractSummary"] = 1;
    };

    // 获取网站群扩展字段
    getColumnExtendField = (data) => {
        let treeId = (data&&data.treeId)||(this.props.dynamicParams && this.props.dynamicParams.treeId || "");
        let mediaId = (data&&data.mediaId)||(this.props.dynamicParams && this.props.dynamicParams.mediaId || "");
        if(treeId && mediaId) {
            this.request({
                url: "/cm-sites-pms/website/getColumnExtendField",
                body: {treeId, mediaId},
                callBack: (res) => {
                    this.state.columnExtendField = res;
                    this.setState({});
                },
            })
        }
    };

    // 获取表单配置项
    getExtendsField = () => {
        this.request({
            url: informationConfig.url,
            callBack: (res) => {
                let variableFieldsSetting = [];
                if (res) {
                    variableFieldsSetting = res;
                }
                this.state.variableFieldsSetting = variableFieldsSetting; // 重置form表单列表
                // this.initializeInformation(informationSetting); // 定义form需要提交的初始值
                this.setState({}, () => {
                    console.log('this.state.variableFieldsSetting', this.state.variableFieldsSetting);
                    console.log('this.state.information', this.state.information)
                });
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };
    // 重写表单数据
    initializeInformation = (informationSetting) => {
        let information = {};
        if (informationSetting.length > 0) {
            informationSetting.forEach(item => {
                if (item['field'] && item['showName']) {
                    information[item['field']] = "";
                }
            })
        }
        this.state.dynamicParams = {...information};
    };

    render() {
        return (
            <Scrollbars autoHeight={true} autoHeightMax={424} autoHeightMin={72}>
                <div id='editorInformation' style={{fontSize: formItemSizeConfig.fontSize}}>
                    {/*标题*/}
                    {this.renderTitle()}
                    {/*表单*/}
                    {this.renderEditorInformation()}
                </div>
            </Scrollbars>
        )
    }

    // 主标题
    renderTitle = () => {
        const {information} = this.state;
        let titleStyle = {};
        if(information && information[informationSetting.variableFieldsKey] && information[informationSetting.variableFieldsKey].titleStyle) titleStyle = information[informationSetting.variableFieldsKey].titleStyle;
        return (
            <div className={'rmt-form-item'} style={{height: formItemSizeConfig.formItemHeight['default']}}>
                {/*label*/}
                <div className={'rmt-form-item-label'}>
                    <div>
                        <span style={{
                            color: '#F56C6C',
                            display: titleSetting.titleIsRequest ? '' : 'none'
                        }}>*</span>{titleSetting.titleName}
                    </div>
                    {informationConfig.showFTitle ? <div style={{marginLeft: 8}} onClick={() => {
                        this.titleAddOrMinus()
                    }}>
                        <Icon type={this.state.titleStatus ? 'minus' : 'plus'}
                              style={{color: '#ffffff', fontSize: 13, background: '#0050B3'}}/>
                    </div> : null}
                </div>
                {/*input*/}
                <div style={{flex: 1}}>
                    <Input
                        id={"information_title"}
                        // style={{...titleStyle}}
                        size={formItemSizeConfig.inputSize}
                        placeholder={titleSetting.titlePlaceholder}
                        onChange={(e) => {
                            this.setData('title', e.target.value);
                        }}
                        value={information.title}
                        disabled={titleSetting.titleDisable}
                        maxLength={titleSetting.titleMaxlength}/>
                    <style>
                        {
                            `
                            #information_title {
                                ${this.formatStyleToHtml(titleStyle)}
                            }
                            `
                        }
                    </style>
                </div>
                {/*setting*/}
                {this.renderTitleSetting()}
            </div>
        )
    };
    /**
     * 输入obj titleStyle  {a:1,b:2}
     * 输出str a:1;b:2;
     * */
    formatStyleToHtml = (titleStyle) => {
        let str = '';
        if(titleStyle instanceof Object) {
            for (let key in titleStyle) {
                // key 为对象的属性名
                // titleStyle[key] 为属性值
                str += `${key}:${titleStyle[key]};`
            }
        }
        return str
    }
    renderTitleSetting = () => {
        let {information, fileList} = this.state;
        let isFontBold = false;
        if(!(
            this.state.information &&
            this.state.information[informationSetting.variableFieldsKey]
        )) {
            this.state.information[informationSetting.variableFieldsKey] = {};
        }
        if(!this.state.information[informationSetting.variableFieldsKey].titleStyle){
            this.state.information[informationSetting.variableFieldsKey].titleStyle = {};
        }
        if(
            this.state.information[informationSetting.variableFieldsKey].titleStyle['font-weight'] &&
            this.state.information[informationSetting.variableFieldsKey].titleStyle['font-weight'] == 'bold'
        ) {isFontBold=true}
        let isFontTilt = false;
        if(
            this.state.information[informationSetting.variableFieldsKey].titleStyle['font-style'] &&
            this.state.information[informationSetting.variableFieldsKey].titleStyle['font-style'] == 'italic'
        ) {isFontTilt=true}
        let toolColor = '#000000';
        if(
            this.state.information[informationSetting.variableFieldsKey].titleStyle['color']
        ) {toolColor=this.state.information[informationSetting.variableFieldsKey].titleStyle['color']}

        let renderTitlePic = ()=>{
            return <img src={information.titlePic ? information.titlePic : titlePic} width={16} height={16} style={{cursor:"pointer"}}
                        onClick={() => {
                            this.setState({},()=>{
                                // 展开合成器
                                this.simpleFloatTool.setMinus(false);
                                // 显示合成器
                                if(this.state.visibleValue){
                                    this.setState({visibleValue:false},()=>{
                                        this.simpleFloatTool.hide()
                                    })
                                }else {
                                    this.setState({visibleValue:true},()=>{
                                        this.simpleFloatTool.show()
                                    })

                                }
                            });
                        }}/>
        };
        if(informationConfig.hideTitleStyleBtn){//隐藏标题样式按钮
            return <div style={{
                width: 24,
                paddingLeft: 8,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
            }}
            >
                {/*标题图*/}
                {renderTitlePic()}
                {this.renderTitlePicFile()}
            </div>
        }

        return (
            <div style={{
                width: 160,
                paddingLeft: 8,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center'
            }}
            >
                {/*字数统计*/}
                <div style={{fontFamily: 'MicrosoftYaHei', color: 'rgba(0, 0, 0, 0.45)', marginRight: 4}}>
                    {information && information.title && information.title.length || 0}字
                </div>
                {/*加粗*/}
                <img className={isFontBold ? 'fontBtnDown' : ''}

                     src={fontBold} width={16} height={16} style={{marginRight: 4,cursor:"pointer"}}
                     onClick={() => {
                         if (!isFontBold) {
                             this.state.information[informationSetting.variableFieldsKey].titleStyle['font-weight'] = 'bold';
                         } else {
                             delete this.state.information[informationSetting.variableFieldsKey].titleStyle['font-weight']
                         }
                         this.setState({fontBold: !this.state.fontBold})
                     }}/>
                {/*倾斜*/}
                <img className={isFontTilt ? 'fontBtnDown' : ''}
                     src={fontTilt} width={16} height={16} style={{marginRight: 7,cursor:"pointer"}}
                     onClick={() => {
                         if (!isFontTilt) {
                             this.state.information[informationSetting.variableFieldsKey].titleStyle['font-style'] = 'italic';
                         } else {
                             delete this.state.information[informationSetting.variableFieldsKey].titleStyle['font-style']
                         }
                         this.setState({fontTilt: !this.state.fontTilt})
                     }}/>
                <style>
                    {
                        `
                                .fontBtnDown{
                                    border-top: solid 1px #000000;
                                    border-left: solid 1px #000000;
                                    border-right: solid 1px #DCDCDC;
                                    border-bottom: solid 1px #DCDCDC;
                                }
                            `
                    }
                </style>
                {/*颜色*/}
                <span style={{cursor:"pointer", width:15}}>
                     <SketchColor
                         setTooloColor={(hex) => {
                             this.state.information[informationSetting.variableFieldsKey].titleStyle['color'] = hex;
                             this.setState({});
                             console.log(hex, 'hex')
                         }}
                         toolColor={toolColor}
                         icon={<img src={fontColorA} width={9}/>}
                         colorEleStyle={{
                             width: 9,
                         }}
                         modalEleStyle={{top: 205, right: -265}}
                     />
                </span>
                {/*清空样式*/}
                <img
                    src={clearFontStyle} width={16} height={16} style={{marginRight: 12, marginLeft: 4,cursor:"pointer"}}
                    onClick={() => {
                        delete this.state.information[informationSetting.variableFieldsKey].titleStyle;
                        this.setState({})
                    }}
                />
                {/*标题图*/}
                {renderTitlePic()}
                {this.renderTitlePicFile()}
            </div>
        )
    };
    renderTitlePicFile = () => {
        let {fileList, hover, videoVisible, information, contentVisible, imgAll, videoAll, currentTime, body} = this.state;
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">上传图片</div>
            </div>
        );
        let Token = getInfoFromLocalStorage('Token');
        return (
            <div className={'uploadModal'}>
                <SimpleFloatTool
                    style={{border: 'none'}}
                    visible={this.state.visibleValue}
                    top={140}
                    title={"标题图片"}
                    left={document.body.clientWidth < 1601 ? document.body.clientWidth - 220 : document.body.clientWidth - 220-280}
                    width={220}
                    onClose={()=>{
                        this.setState({visibleValue:false})}}
                    footer={<div
                        style={{color: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"), display: 'flex', justifyContent: 'space-around'}}>
                        <span style={{cursor: 'pointer'}} onClick={() => {
                            this.imgChoose.showModal();
                            this.contentChoose();
                        }}>正文选择</span>
                        <span style={{cursor: 'pointer'}} onClick={() => {
                            this.videoCaptureContent()
                        }}>视频截取</span>
                    </div>}
                    ref={simpleFloatTool => this.simpleFloatTool = simpleFloatTool}
                >
                    <Upload
                        name="avatar"
                        accept={"." + this.state.newPicType.join(",.")}
                        listType="picture-card"
                        className="avatar-uploader"
                        style={{textAlign: 'center', position: 'relative'}}
                        headers={{Authorization: 'Bearer ' + Token}}
                        showUploadList={false}
                        action="/storage/uploadFile"
                        fileList={fileList}
                        onPreview={this.handlePreview}
                        // onChange={this.handleChange}
                        customRequest={new ChunkUpload({
                            checkFileURL: "/storage/checkFile",
                            checkChunkURL: "/storage/checkChunk",
                            uploadChunkURL: "/storage/uploadChunk",
                            chunkUploadOverURL: "/storage/chunkIsUploadOver",
                            mergeChunksURL: "/storage/mergeChunk"
                        }).start}
                        beforeUpload={this.beforeUploadTitle}
                        onChange={this.onChangeTitle}
                        showPercent={false}
                    >
                        {information.titlePic ?
                            <img src={information.titlePic} alt="avatar"
                                 style={{width: '85px', height: '85px', objectFit: 'cover'}}
                                 className={'uploadHover'}
                                 onMouseEnter={() => this.handleEnter()}
                            /> : uploadButton}
                    </Upload>
                    {/*悬浮按钮*/}
                    {hover ? this.renderBtn() : null}

                    {/*预览*/}
                    <Picture ref={ref=>this.detailDialog=ref} path={information.titlePic}/>
                    {/*正文选择*/}
                    <ImgChoose getImgChoose={(data) => this.getImgChoose(data)} imgAll={imgAll}
                               ref={e => this.imgChoose = e}/>
                    {/*视频截取*/}
                    <VideoCapture getVideoPicture={(data) => this.getVideoPicture(data)} videoAll={videoAll}
                                  ref={e => this.videoCapture = e}/>
                </SimpleFloatTool>
                <style>
                    {`
                            .uploadModal .ant-upload.ant-upload-select-picture-card{
                                margin-left:43px;
                            }
                            .uploadModal tr:nth-child(2) td{
                                border:none !important;
                                padding:0px 0px 0px 15px !important;
                            }
                            .uploadModal tr:nth-child(3) td{
                                border:none !important;
                                padding:5px 20px 7px !important;
                            }
                    `}
                </style>
            </div>

        )
    };
    //鼠标悬浮图片按钮
    renderBtn = () => {
        return (
            <div style={{
                display: 'block'
            }} onMouseLeave={() => this.handleOut()}>
                <div style={{
                    width: 104,
                    height: 104,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    position: 'absolute',
                    top: 0,
                    left: 43,
                    padding: '0 10px'
                }}>
                    <Icon type={'eye'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => this.handlePreview()}
                    />
                    <Icon type={'delete'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={this.handleDelete}
                    />
                    <Icon type={'edit'} style={{width: 20, height: 20, color: "#fff", cursor: 'pointer'}}
                          onClick={() => {
                              let imgName = "";
                              this.handleEdit(this.state.information.titlePic, imgName)
                          }}
                    />
                </div>
            </div>
        )
    };
    //传视频帧
    getVideoPicture = (data) => {
        // let { videoAll } = this.state;
        // console.log(videoAll)
        if (data) {
            this.setState({
                videoVisible: false,
                information: {
                    ...this.state.information,
                    titlePic: data
                },
            })
        }
    };
    // 传标题图
    getImgChoose = (data) => {
        if (data) {
            this.setState({
                contentVisible: false,
                information: {
                    ...this.state.information,
                    titlePic: data
                },
            })
        }
    };
    // 预览
    handlePreview = async file => {
        this.detailDialog.show();
    };
    // handleChange = ({fileList}) => this.setState({fileList});
    // 删除按钮
    handleDelete = () => {
        this.setState({
            hover: false,
            information: {
                ...this.state.information,
                titlePic: ""
            }
        })
    };
    //鼠标移入
    handleEnter = () => {
        this.setState({
            hover: true,
        })
    };
    // 编辑
    handleEdit = (pictureUrl, name) => {
        let that = this;
        window.edit.callback = function (obj) {
            console.log(this.setState);
            that.setState({
                information: {
                    ...that.state.information,
                    titlePic: obj.path
                }
            })
        };
        window.edit.openEditPictureFrame(pictureUrl, name);
    };
    handleOut = (e) => {
        this.setState({
            hover: false,
        })
    };
    renderFTitle = () => {
        const {
            information, checkedTitleList, titleStatus
        } = this.state;
        if(!information[informationSetting.variableFieldsKey]){
            information[informationSetting.variableFieldsKey]={}
        }

        let editor_menus = [
            'head','fontName', 'fontSize','bold','italic','underline','justify','foreColor','backColor','list','undo', 'redo',
        ];
        return (
            <>
                {titleStatus && informationConfig.showFTitle ?
                    <div style={{paddingLeft: "100px"}}>
                        <Checkbox.Group options={plainOptions} value={checkedTitleList}
                                        onChange={checkedValues => this.checkboxOnChange(checkedValues)}/>
                    </div> : null}
                {titleStatus && informationConfig.showFTitle ?
                    <div>
                        {checkedTitleList.includes(informationSetting.wbcontenttitleName) ?
                            <div className="rmt-form-item" style={{paddingBottom:"5px"}}>
                                <div className="rmt-form-item-label" style={{alignSelf:"start"}}>{informationSetting.wbcontenttitleName}</div>
                                <div className={'rmt-form-item-control-wrapper'} style={{width:'calc(100% - 75px)'}}>
                                    <Editors
                                     content={information[informationSetting.variableFieldsKey][informationSetting.wbcontenttitleKey]}
                                     isUpDate={this.state.isUpDate}
                                     customHeight={100}
                                     editorEnable={informationSetting.wbcontenttitleDisable}
                                     callBackeditorContent={(content,txt)=>{
                                         this.state.isUpDate=false;
                                         let newContent = content;
                                         let newText = txt.replace(/&nbsp;/g,"").replace(/\s/g,"");
                                         if(!(newText&&newText.length)) {
                                             newContent = ""
                                         }
                                         this.setData([informationSetting.wbcontenttitleKey], newContent,informationSetting.variableFieldsKey)
                                     }}
                                     menus={editor_menus}
                                    />
                                </div>
                            </div> : ""
                        }
                        {checkedTitleList.includes(informationSetting.headlinesName) ?
                            <div className="rmt-form-item"
                                 style={{height: formItemSizeConfig.formItemHeight['default']}}>
                                <div className="rmt-form-item-label">{informationSetting.headlinesName}</div>
                                <div className={'rmt-form-item-control-wrapper'}>
                                    <Input
                                        id={"information_headlines"}
                                        size={formItemSizeConfig.inputSize}
                                        placeholder={informationSetting.headlinesPlaceholder}
                                        disabled={informationSetting.headlinesDisable}
                                        maxLength={informationSetting.headlinesMaxlength}
                                        onChange={(e) => {
                                            this.setData(informationSetting.headlinesKey, e.target.value,informationSetting.variableFieldsKey)
                                        }} value={information[informationSetting.variableFieldsKey][informationSetting.headlinesKey]}
                                    ></Input>
                                </div>
                            </div> : ""
                        }
                        {checkedTitleList.includes(informationSetting.ftitleName) ?
                            <div className="rmt-form-item"
                                 style={{height: formItemSizeConfig.formItemHeight['default']}}>
                                <div className="rmt-form-item-label">{informationSetting.ftitleName}</div>
                                <div className={'rmt-form-item-control-wrapper'}>
                                    <Input
                                        id={"information_ftitle"}
                                        size={formItemSizeConfig.inputSize}
                                        placeholder={informationSetting.ftitlePlaceholder}
                                        disabled={informationSetting.ftitleDisable}
                                        maxLength={informationSetting.ftitleMaxlength}
                                        onChange={(e) => {
                                            this.setData(informationSetting.ftitleKey, e.target.value,informationSetting.variableFieldsKey)
                                        }} value={information[informationSetting.variableFieldsKey][informationSetting.ftitleKey]}/>
                                </div>
                            </div> : ""
                        }
                        {checkedTitleList.includes(informationSetting.eyebrowName) ?
                            <div className="rmt-form-item"
                                 style={{height: formItemSizeConfig.formItemHeight['default']}}>
                                <div className="rmt-form-item-label">{informationSetting.eyebrowName}</div>
                                <div className={'rmt-form-item-control-wrapper'}>
                                    <Input
                                        id={"information_eyebrow"}
                                        size={formItemSizeConfig.inputSize}
                                        placeholder={informationSetting.eyebrowPlaceholder}
                                        disabled={informationSetting.eyebrowDisable}
                                        maxLength={informationSetting.eyebrowMaxlength}
                                        onChange={(e) => {
                                            this.setData( informationSetting.eyebrowKey,e.target.value,informationSetting.variableFieldsKey)
                                        }} value={information[informationSetting.variableFieldsKey][informationSetting.eyebrowKey]}
                                    ></Input>
                                </div>
                            </div> : ""
                        }
                    </div> : null}

                    {/*<div onClick={()=>{this.checkInfor()}}>验证</div>*/}
            </>
        )
    };
    // 渲染表单
    renderEditorInformation = () => {
        let {information, keywordDefaultChecked, summaryDefaultChecked} = this.state;
        const {contentText, informationStatus} = this.props;
        // if (keywordDefaultChecked) {
        //     information.keyword = contentText
        // }
        // if (summaryDefaultChecked && !this.state.information.summary) {
        //     this.state.information.summary = contentText
        // }
        return (
            <div style={{display: informationStatus ? '' : 'none'}}>
                {/*副标题等*/}
                {this.renderFTitle()}
                {/*动态渲染的表单*/}
                <Row gutter={24}>
                    {this.renderDynamicForm()}
                    {this.renderSourceDeptNameField()}
                </Row>
                {/*标签*/}
                {this.renderLabel()}
                {/*站群扩展字段*/}
                <Row gutter={24}>{this.renderColumnExtendField()}</Row>
                {/*跳转链接*/}
                {/*{this.renderMipLink()}*/}
                {/*上传附件*/}
                {this.renderUpload()}
                {/*附件列表*/}
                {this.renderAttach()}
                {/*<div onClick={() => {*/}
                {/*    this.checkInfo()*/}
                {/*}}> 验证*/}
                {/*</div>*/}
                {/*<div onClick={() => {*/}
                {/*    console.log('this.setInformation', this.setInformation);*/}
                {/*    this.setInformation({*/}
                {/*        title: '标题',*/}
                {/*        author: '作者',*/}
                {/*        phone: '作者电话',*/}
                {/*        photography: '摄影',*/}
                {/*        camera: '摄像',*/}
                {/*        editor: '编辑',*/}
                {/*        setInformation: false,*/}
                {/*        summary: '摘要',*/}
                {/*        label: ['标签']*/}
                {/*    })*/}
                {/*}}> 设置内容*/}
                {/*</div>*/}
                {/*<div>*/}
                {/*    <Input value={this.state.labelKey} onChange={(e)=>{*/}
                {/*        this.setState({*/}
                {/*            labelKey: e.target.value*/}
                {/*        })*/}
                {/*    }}/>*/}
                {/*    <Button onClick={()=>{*/}
                {/*        this.setFocus(this.state.labelKey)*/}
                {/*    }}>获取焦点</Button>*/}
                {/*</div>*/}
            </div>
        )
    };
    // 渲染动态表单
    renderDynamicForm = () => {
        const {variableFieldsSetting} = this.state;
        const children = [];
        for (let i = 0; i < variableFieldsSetting.length; i++) {
            let formItem = variableFieldsSetting[i];
            let span = informationConfig[formItem[regulation["labelCode"]]] || informationConfig['default'];
            let defaultHeight = formItemSizeConfig.formItemHeight['default'];
            let formItemHeight = formItemSizeConfig.formItemHeight[formItem[regulation["labelType"]]] || defaultHeight;
            let required = formItem[regulation["required"]];
            let labelName = formItem[regulation["labelName"]];
            children.push(
                <Col span={span} key={i}>
                    <div className={'rmt-form-item'} style={{height: formItemHeight}}>
                        <div className={'rmt-form-item-label'}>
                            <label
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    marginBottom: formItemHeight - defaultHeight
                                }}
                                className={required ? 'rmt-form-item-required' : ''}
                                title={formItem['showName']}
                            >
                                <span style={{
                                    color: '#F56C6C',
                                    display: required ? '' : 'none'
                                }}>*</span>
                                {labelName}
                            </label>
                        </div>
                        <div className={'rmt-form-item-control-wrapper'}>
                            {this.renderFormItemControl(formItem)}
                        </div>
                    </div>
                </Col>
            );
        }
        return children;
    };
    // 动态渲染输入框
    renderFormItemControl = (formItem) => {
        const {contentText} = this.props;
        let type = formItem[regulation['labelType']];
        let disabled = formItem[regulation['disabled']];
        let field = formItem[regulation['labelCode']];
        let onChange = this.formItemOnChangeByDynamicParams;
        let onChangeOfState = this.onChangeOfState;
        let variableFieldsKey = regulation["variableFieldsKey"];
        let wbextends = this.state.information[variableFieldsKey];
        let notShowEditor = this.state.checkedValue ? true : false;
        if(!wbextends) {
            this.state.information[variableFieldsKey]={}
        }
        let value = this.state.information[variableFieldsKey][field];
        // let summaryDefaultChecked = this.state.summaryDefaultChecked;
        let autoExtractSummary = this.state.information[variableFieldsKey]["autoExtractSummary"];
        if(autoExtractSummary !== 1 && autoExtractSummary !== 0) {
            // 非正常自动提取参数，默认自动提取摘要
            this.state.information[variableFieldsKey]["autoExtractSummary"] = 1;
            autoExtractSummary = 1;
        }
        let props = {
            type,
            disabled,
            field,
            onChange,
            value,
            // summaryDefaultChecked,
            autoExtractSummary,
            contentText,
            onChangeOfState,
            formItemSizeConfig,
            id: "information_" + field,
            notShowEditor
        };
        let RmtInput;
        if (typeof type == "string") {
            RmtInput = require(`./formItem/${type}`); // 引入输入框
        }
        return (
            <div className={'rmt-form-item-control-control'}>
                {RmtInput ?
                    <RmtInput.default {...props} />
                    : <div></div>}
            </div>
        )
    };

    // 渲染来稿单位字段
    renderSourceDeptNameField = () => {
        const { information } = this.state;
        const sourceDeptNameVal = information['sourceDeptName'];
        let span = informationConfig['sourceDeptName'] || informationConfig['default'];
        let defaultHeight = formItemSizeConfig.formItemHeight['default'];
        let formItemHeight = formItemSizeConfig.formItemHeight['text'] || defaultHeight;
        return (
            <>
                {
                    sourceDeptNameVal && (
                        <Col span={span} key='sourceDeptName'>
                            <div className={'rmt-form-item'} style={{height: formItemHeight}}>
                                <div className={'rmt-form-item-label'}>
                                    <label
                                        style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            marginBottom: formItemHeight - defaultHeight
                                        }}
                                        className=''
                                        title='来稿单位'
                                    >
                                        来稿单位
                                    </label>
                                </div>
                                <div className={'rmt-form-item-control-wrapper'}>
                                    {this.renderSourceDeptNameControl()}
                                </div>
                            </div>
                        </Col>
                    )
                }
            </>
        )
    }

    // 渲染来稿单位输入框
    renderSourceDeptNameControl = () => {
        let type = 'text';
        let field = 'sourceDeptName';
        let value = this.state.information[field];
        let props = {
            type,
            disabled: true,
            field,
            value,
            formItemSizeConfig,
            id: "information_" + field,
        };
        let RmtInput;
        if (typeof type == "string") {
            RmtInput = require(`./formItem/${type}`); // 引入输入框
        }
        return (
            <div className={'rmt-form-item-control-control'}>
                {RmtInput ?
                    <RmtInput.default {...props} />
                    : <div></div>}
            </div>
        )
    }

    // 渲染站群扩展字段
    renderColumnExtendField = () => {
        const {columnExtendField} = this.state;
        const children = [];
        for (let i = 0; i < columnExtendField.length; i++) {
            let formItem = columnExtendField[i];
            let key = formItem[columnExtendFieldSetting.key];
            let type = formItem[columnExtendFieldSetting.type];
            let required = formItem[columnExtendFieldSetting.required];
            let label = formItem[columnExtendFieldSetting.label];
            let span = informationConfig[type] || informationConfig['default'];
            let formItemHeight = formItemSizeConfig.formItemHeight[type] || formItemSizeConfig.formItemHeight['default'];
            children.push(
                <Col span={span} key={i}>
                    <div className={'rmt-form-item'} style={{height: formItemHeight}}>
                        <div className={'rmt-form-item-label'}>
                            <label
                                style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    marginBottom: formItemHeight - formItemSizeConfig.formItemHeight['default'],
                                    color: this.themeBgColor
                                }}
                                className={required ? 'rmt-form-item-required' : ''}
                                title={label}
                            >
                                <span style={{
                                    color: '#F56C6C',
                                    display: required ? '' : 'none'
                                }}>*</span>
                                {label}
                            </label>
                        </div>
                        <div className={'rmt-form-item-control-wrapper'}>
                            {this.renderColumnExtendFieldControl(formItem)}
                        </div>
                    </div>
                </Col>,
            );
        }
        return children;
    };
    // 动态站群扩展字段输入框
    renderColumnExtendFieldControl = (formItem) => {
        const {contentText} = this.props;
        let type = formItem[columnExtendFieldSetting.type];
        let disabled = formItem[columnExtendFieldSetting.disabled];
        let field = formItem[columnExtendFieldSetting.key];
        let selectvalue = formItem[columnExtendFieldSetting.selectvalue];
        let onChange = this.formItemOnChangeBywbextends;
        let onChangeOfState = this.onChangeOfState;
        let variableFieldsKey = columnExtendFieldSetting["variableFieldsKey"];
        let wbextends = this.state.information[variableFieldsKey];
        if(!wbextends) {
            this.state.information[variableFieldsKey]={}
        }
        let value = this.state.information[variableFieldsKey][field];
        let props = {
            type,
            disabled,
            field,
            onChange,
            value,
            contentText,
            onChangeOfState,
            formItemSizeConfig,
            selectvalue,
            id: "information_" + field,
        };
        let RmtInput;
        if (typeof type == "string") {
            RmtInput = require(`./formItem/${type}`); // 引入输入框
        }
        return (
            <div className={'rmt-form-item-control-control'}>
                {RmtInput ?
                    <RmtInput.default {...props} />
                    : <div></div>}
            </div>
        )
    };
    // 标签
    renderLabel = () => {
        let {information, labelInputVal} = this.state;
        return (
            <div className={'rmt-form-item'} style={{display: 'flex', lineHeight: '40px', alignItems: 'flex-start'}}>
                <div className={'rmt-form-item-label'}>{informationSetting.labelName}</div>
                <div style={{flex: 1}}>
                    <div style={{display: 'inline-block'}}>
                        <Input
                            id={"information_label"}
                            style={{width: 251, display: 'inline-block', flex: 'unset'}}
                            size={formItemSizeConfig.inputSize}
                            placeholder={informationSetting.labelPlaceholder}
                            disabled={informationSetting.labelDisable}
                            maxLength={informationSetting.labelMaxlength}
                            onChange={(e) => {
                                this.setState({labelInputVal: e.target.value});
                            }} value={labelInputVal}
                        />
                        <Button icon="plus"
                                style={{
                                    width: 32,
                                    lineHeight: '17px',
                                    margin: '0 10px',
                                    color: '#595a5b',
                                    display: 'inline-block',
                                }}
                                onClick={() => {
                                    if (!information[informationSetting.variableFieldsKey].label) {
                                        information[informationSetting.variableFieldsKey].label = []
                                    }
                                    if (!information[informationSetting.variableFieldsKey].label.includes(labelInputVal) && labelInputVal) {
                                        let newLabelArr = [...information[informationSetting.variableFieldsKey].label, labelInputVal];
                                        this.setData( informationSetting.labelKey,newLabelArr,informationSetting.variableFieldsKey)
                                    }
                                    this.setState({labelInputVal:""});
                                }}
                        ></Button>
                        {information && information[informationSetting.variableFieldsKey] && information[informationSetting.variableFieldsKey].label && information[informationSetting.variableFieldsKey].label.length > 0 ?
                            information[informationSetting.variableFieldsKey].label.map(item => (
                                <div key={item}
                                     style={{
                                         display: 'inline-block',
                                         padding: '0 8px',
                                         width: 'auto',
                                         margin: '0px 8px 0px 0px',
                                         lineHeight: formItemSizeConfig.inputHeight + 'px',
                                         border: '1px solid #dcdcdc',
                                         borderRadius: '5px',
                                     }}>
                                    {item}
                                    <Icon type="close"
                                          onClick={() => {
                                              // information[informationSetting.variableFieldsKey].label = information[informationSetting.variableFieldsKey].label.filter(label => label !== item);
                                              let newLabelArr = information[informationSetting.variableFieldsKey].label.filter(label => label !== item);
                                              this.setData( informationSetting.labelKey,newLabelArr,informationSetting.variableFieldsKey);
                                              // this.setState({});
                                          }}
                                          style={{
                                              marginLeft: 8,
                                              fontSize: 12,
                                              cursor: 'pointer',
                                              color: '#afafaf',
                                          }}/>
                                </div>
                            ))
                            : null
                        }
                    </div>
                </div>
            </div>
        )
    };
    // 上传文件
    renderUpload = () => {
        if(informationConfig.hideUpload){
            return <></>;
        }
        let {attach} = this.state.information;
        return (
            <div className="rmt-form-item" style={{height: formItemSizeConfig.formItemHeight['default']}}>
                <div className="rmt-form-item-label">{informationSetting.uploadName}</div>
                <div className={'rmt-form-item-control-wrapper'}>
                    <Button id={"information_attach"} size={formItemSizeConfig.inputSize} style={{width: '106px'}}
                            onClick={this.uploadShowModal}>
                        <Icon type="upload"/> 上传文件
                    </Button>
                    <UploadFiles
                        attach={attach}
                        onCancelCall={(file) => {
                            this.uploadHandleCancel();
                            this.uploadHandleOk(file)
                        }}
                        uploadVisible={this.state.uploadVisible}
                        onChange={(file) => {
                            this.uploadHandleOk(file)
                        }}
                        onOkCall={(file) => {
                            this.uploadHandleOk(file)
                        }}
                    />
                    <div className="row-select"
                         style={{marginLeft: 8}}>当前附件 {attach && attach.length ? attach.length : 0} 个
                    </div>
                </div>
            </div>
        )
    };

    // 附件列表
    renderAttach = () => {
        if(informationConfig.hideUpload){
            return <></>;
        }
        let canInsertionFileExt = [...PIC_TYPE, ...VIDEO_TYPE, ...AUDIO_TYPE];
        let {attach} = this.state.information;
        return (
            <div style={{padding: '5px 32px 5px 90px'}}>
                {
                    attach && attach.length > 0 ?
                        attach.map(item => {
                            let oldName = item.name;
                            let name = oldName;
                            let suffix = "";
                            if (oldName && oldName.indexOf('.') > -1) {
                                let arr = oldName.split('.');
                                name = arr.slice(0, arr.length - 1).join('.');
                                suffix = arr.at(-1);
                            }
                            let ext = item.ext;
                            return (
                                <div key={item.md5 || item.uid} className={'attachItem'} style={{display: 'flex', width: '100%'}}>
                                    <div style={{
                                        width: 'calc(100% - 132px)', color: '#989b9d', display: 'flex'
                                    }}
                                         title={item.name}
                                    >
                                        <div style={{
                                            maxWidth: '90%', overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap'
                                        }}>{name}.
                                        </div>
                                        <div>{suffix}</div>
                                    </div>
                                    <div style={{display: 'flex', width: 132, justifyContent: 'flex-end'}}>
                                        {
                                            canInsertionFileExt.includes(suffix) && !AUDIO_TYPE.includes(suffix) || this.state.newPicType.includes(suffix) ?
                                                <div style={{
                                                    color: this.themeBgColor,
                                                    margin: '0 8px',
                                                    cursor: 'pointer'
                                                }}
                                                     onClick={() => {
                                                         console.log(item)
                                                         let fileHTML;

                                                         if (this.state.newPicType.includes(suffix)) {
                                                             fileHTML = buildInsertPicHtml({
                                                                 url: item.smallPath?item.smallPath:item.url,
                                                                 sourceUrl:item.url,
                                                                 title: item.name,
                                                                 width: item.cssWidth
                                                             })
                                                         } else if (VIDEO_TYPE.includes(suffix)) {

                                                             this.getStorageFileByUrl(item.url,(picSrc,duration,videoPic,url)=>{
                                                                 fileHTML = buildInsertVideoHtml({url: url,videoPic:videoPic, name:item.name, width: item.cssWidth, playUrl: picSrc,duration:duration})
                                                                 let isSuccess = window.ueditor.rmtExecCommand("inserthtml", fileHTML);
                                                             });
                                                             return
                                                         }
                                                         // else if (AUDIO_TYPE.includes(suffix)) {
                                                         //     message.info("暂不支持音频插入")
                                                         //     fileHTML = '<audio controls autoplay="false" src="' + item.url + '" width="' + (item.cssWidth ? parseInt(item.cssWidth) : 500) + 'px" />';
                                                         // }
                                                         if (fileHTML) {
                                                             let isSuccess = window.ueditor.rmtExecCommand("inserthtml", fileHTML);
                                                         }
                                                     }}
                                                >插入
                                                </div>
                                                : null
                                        }
                                        <div style={{color: this.themeBgColor, margin: '0 8px', cursor: 'pointer'}}
                                             onClick={() => {
                                                 this.downloadFile(item);
                                             }}
                                        >下载
                                        </div>
                                        <div style={{color: this.themeBgColor, margin: '0 8px', cursor: 'pointer'}}
                                             onClick={() => {
                                                 this.delAttachByMd5(item.md5)
                                             }}
                                        >删除
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        : null
                }
            </div>
        )
    };
    getStorageFileByUrl(url,call) {
         if(url && url.match(/\/storage\/[A-Za-z0-9]{32,}\S*/)){
            this.request({
                url: `/storage/getStorageFileByUrl?url=${url}`,
                contentType: "json",
                callBack: (data) => {
                    let picSrc = '';
                    let duration = '';
                    let videoPic = '';
                    let url='';
                    if(data){
                        picSrc = data.thumbnailsPlayPath
                        duration = data.duration
                        url=data.mp4Path
                        videoPic = data.thumbnailsPath
                    }
                    call&&call(picSrc,duration,videoPic,url)
                    // this.setState({picSrc})
                }
            });
        }
    }

    // 删除附件
    delAttachByMd5 = (md5) => {
        let {attach} = this.state.information;
        let fileList = attach.filter(Item => Item.md5 !== md5);
        this.uploadHandleOk(fileList)
    };

    // 下载附件
    downloadFile = (item) => {
        let path = item.url;
        path = path + '?download=1';
        window.open(`${path}`, '_blank');
    };

    // 摘要
    renderAbstract = () => {
        const {
            information,
            synopsisDefaultChecked,
        } = this.state;
        const {contentText} = this.props;
        return (
            <div className="form-row">
                <div className="row-label">{informationSetting.synopsisName}</div>
                <div className="row-input">
                    <TextArea style={{height: '88px'}}
                              placeholder={informationSetting.synopsisPlaceholder}
                              disabled={informationSetting.synopsisDisable}
                              maxLength={informationSetting.synopsisMaxlength}
                              onChange={(e) => {
                                  this.setState({synopsisDefaultChecked: false});
                                  this.setData('synopsis', e.target.value)
                              }}
                              value={synopsisDefaultChecked ? contentText.substr(0, 30) : information.synopsis}
                    />
                    <div style={{alignSelf: "flex-end", marginLeft: '8px', whiteSpace: "nowrap"}}>
                        <Checkbox checked={this.state.synopsisDefaultChecked}
                                  onChange={e => {
                                      this.setData('synopsis', "");
                                      this.setState({synopsisDefaultChecked: e.target.checked})
                                  }}>自动提取</Checkbox>
                    </div>
                </div>
            </div>
        )
    };
    // 关键字
    renderKeyword = () => {
        const {
            information, keywordDefaultChecked,
        } = this.state;
        const {contentText} = this.props;
        if (keywordDefaultChecked) {
            information.keyword = contentText
        }
        return (
            <div className="form-row">
                <div className="row-label"><span style={{color: 'red'}}>*</span>{informationSetting.keywordName}
                </div>
                <div className="row-input">
                    <Input
                        placeholder={informationSetting.keywordPlaceholder}
                        disabled={informationSetting.keywordDisable}
                        maxLength={informationSetting.keywordMaxlength}
                        onChange={(e) => {
                            this.setState({keywordDefaultChecked: false})
                            this.setData('keyword', e.target.value)
                        }} value={information.keyword}
                    ></Input>
                    <div style={{width: 76, marginLeft: 8, whiteSpace: "nowrap"}}>
                        <Checkbox
                            checked={this.state.keywordDefaultChecked}
                            onChange={e => {
                                this.setData('keyword', "");
                                this.setState({keywordDefaultChecked: e.target.checked})
                            }}
                        >
                            <span>自动提取</span>
                        </Checkbox>
                    </div>
                </div>
            </div>
        )
    };
    // 跳转链接
    renderMipLink = () => {
        const {information} = this.state;
        return (
            <div className={'rmt-form-item'} style={{display: 'flex', lineHeight: '40px', alignItems: 'flex-start'}}>
                <div className={'rmt-form-item-label'}>{informationSetting.mipLinkName}</div>
                <div style={{flex: 1}}>
                    <Input
                        placeholder={informationSetting.mipLinkPlaceholder}
                        disabled={informationSetting.mipLinkDisable}
                        maxLength={informationSetting.mipLinkMaxlength}
                        onChange={(e) => {
                            this.setData('linkurl', e.target.value)
                        }}
                        value={this.state.checkedValue?information.linkurl:''}
                        disabled={this.state.checkedValue?false:true}
                    >
                    </Input>
                </div>
                    <div style={{marginLeft: '8px', width: '16px'}}>
                        <Checkbox
                            checked={this.state.checkedValue}
                            onChange={(e)=>{
                                this.state.checkedValue= e.target.checked;
                                this.onLinkCheckedCall(!this.state.checkedValue);
                            }}
                        />
                    </div>
            </div>
        )
    };
    onLinkCheckedCall=(status)=>{
        this.props.onLinkCheckedCall&&this.props.onLinkCheckedCall(status)
    }
    // 来源
    renderSource = () => {
        const {
            information
        } = this.state;
        return (
            <div className="form-row">
                <div className="row-label"><span style={{color: 'red'}}>*</span>{informationSetting.sourceName}
                </div>
                <div className="row-input">
                    <Input
                        placeholder={informationSetting.sourcePlaceholder}
                        disabled={informationSetting.sourceDisable}
                        maxLength={informationSetting.sourceMaxlength}
                        // onChange={(e) => {
                        //     this.setData('source', e.target.value)
                        // }}
                        value={information.source}
                    />
                    <div style={{marginLeft: '8px', whiteSpace: "nowrap", cursor: "pointer", width: '48px'}}
                         onClick={this.showModal}>选择来源
                    </div>
                    <SelectSource handleOk={data => this.handleOk(data)}
                                  handleCancel={() => this.handleCancel()}
                                  visible={this.state.visible}/>
                </div>
            </div>
        )
    };
    // 标题图上传前校验
    beforeUploadTitle = async file => {
        this.state.newPicTypeList = [...this.state.newPicType,...this.state.newPicType.toUpperCase()]
        let res = this.state.newPicTypeList.find(item => file.name.endsWith(item));
        return new Promise((resolve, reject) => {
            if (res) {
                resolve(file);
            } else {
                message.error(`${file.name}图片格式不正确，只能上传以下图片格式：${this.state.newPicType.join("，")}`);
                reject();
            }
        });
    };
    // 标题图上传
    onChangeTitle = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        let fileList = [info.fileList.at(-1)];
        this.state.fileList = fileList;
        this.state.information.titlePic = fileList[0].url;
        if (info.file.status === 'uploading') {
            this.setState({loading: true});
            return;
        } else if (info.file.status === 'done') {
            this.setState({
                loading: false,
            })
        } else {
            this.setState({});
        }
    };
    // 固定表单change事件
    setData(key, val,variableFieldsKey='') {
        if(variableFieldsKey==informationSetting.variableFieldsKey){
            this.state.information[variableFieldsKey][key] = val;
        }else{
            this.state.information[key] = val;
        }
        this.setState({}, () => {
            console.log(this.state.information)
        });
        this.callBackOnChange(key, val)
    };
    // 动态表单change事件
    formItemOnChangeByDynamicParams = (field, val, isFirst) => {
        let variableFieldsKey = regulation["variableFieldsKey"];
        let wbextends = this.state.information[variableFieldsKey];
        if(!wbextends) {
            this.state.information[variableFieldsKey]={}
        }
        this.state.information[variableFieldsKey][field] = val;
        this.state.dynamicParams[field] = val;
        this.setState({});
        if(!isFirst) {
            this.callBackOnChange(field, val)
        }
    };
    // 动态站群表单change事件
    formItemOnChangeBywbextends = (field, val) => {
        let variableFieldsKey = columnExtendFieldSetting["variableFieldsKey"];
        let wbextends = this.state.information[variableFieldsKey];
        if(!wbextends) {
            this.state.information[variableFieldsKey]={}
        }
        this.state.information[variableFieldsKey][field] = val;
        this.state.wbextends[field] = val;
        this.setState({});
        this.callBackOnChange(field, val)
    };
    // 输入框内容改变时回传
    callBackOnChange = (key, val) => {
        this.props.formItemOnChange&&this.props.formItemOnChange(key, val)
    };
    // 修改state事件（文本域勾选事件等）
    onChangeOfState = (field, val) => {
        this.state[field] = val;
        this.setState({});
    };
    // 标题加减号点击
    titleAddOrMinus() {
        // 调父页面方法展开基本信息
        this.props.titleAddOrMinus();
        let titleStatus = this.state.titleStatus;
        if(!titleStatus) {
            // 即将展开
            // 强塞内容标题内容
            this.state.isUpDate = true;
        }
        this.setState({
            titleStatus: !titleStatus,
        })
    };
    // 附件上传
    uploadHandleOk = (fileList) => {
        this.state.information.attach = fileList;
        this.props.formItemOnChange&&this.props.formItemOnChange("upload",fileList)
        this.setState({});
    };
    // 上传附件弹窗关闭
    uploadHandleCancel = () => {
        this.setState({
            uploadVisible: false,
        });
    };
    // 上传附件弹窗打开
    uploadShowModal = () => {
        this.setState({
            uploadVisible: true,
        });
    };
    // 选择来源
    handleOk = (data) => {
        const {information} = this.state;
        this.setState({
            information: {...information, source: data}
        }, () => {
            console.log(this.state.information.source)
        });
        this.handleCancel();
    };
    // 来源弹窗关闭
    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };
    // 来源弹窗打开
    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    messageKey;
    // 验证信息
    checkInformation() {
        message.destroy();
        const {information, dynamicParams, checkedTitleList, variableFieldsSetting} = this.state;
        let checkStatus = true;
        //少了验证
        if(!this.messageKey){
            this.messageKey = "a"+uuid();
        }

        //验证标题
        if (titleSetting.titleIsRequest && !(information.title && information.title.trim())) {
            this.setFocus("title");
            message.warn({key:this.messageKey, content:titleSetting.titleCheckMessage});
            checkStatus = false;
            return checkStatus
        }
        if(information.title.trim() === "null"){
            this.setFocus("title");
            message.warn({key:this.messageKey, content:"标题格式不正确！"});
            checkStatus = false;
            return checkStatus
        }
        // 验证内容标题
        let wbcontenttitle = this.state.information[informationSetting.variableFieldsKey] ? this.state.information[informationSetting.variableFieldsKey][informationSetting.wbcontenttitleKey] || '' : '';
        if(wbcontenttitle && wbcontenttitle.length && informationSetting.wbcontenttitleMaxlength && wbcontenttitle.length>informationSetting.wbcontenttitleMaxlength) {
            message.warn({key:this.messageKey, content:`内容标题最大内容不得超过${informationSetting.wbcontenttitleMaxlength}字符！`});
            checkStatus = false;
            return checkStatus
        }
        //验证标签
        if (
            variableFieldsSetting.labelRequest &&
            informationSetting.variableFieldsKey &&
            information[informationSetting.variableFieldsKey] &&
            !information[informationSetting.variableFieldsKey].label
        ) {
            // 调父页面方法展开基本信息
            this.props.titleAddOrMinus();
            message.warn({key:this.messageKey, content:variableFieldsSetting.labelMessage});
            checkStatus = false;
            return checkStatus
        }
        // 校验动态参数
        let variableFieldsKey = regulation["variableFieldsKey"];
        try {
            variableFieldsSetting.forEach(item => {
                if (
                    item.required &&
                    information[variableFieldsKey] &&
                    item[regulation['labelCode']] &&
                    !information[variableFieldsKey][item[regulation['labelCode']]]
                ) {
                    // 如果选择了自动提取，则不校验摘要
                    if(!(item[regulation['labelCode']] === 'summary' && information[variableFieldsKey]['autoExtractSummary']===1)) {
                        // 调父页面方法展开基本信息
                        this.props.titleAddOrMinus();
                        message.warn({key:this.messageKey, content:"请输入" + item[regulation['labelName']]});
                        checkStatus = false;
                        throw new Error("请输入" + item[regulation['labelName']]);
                        return checkStatus
                    }
                }
                if(
                    item.regx &&
                    !(new RegExp(item.regx)).test(information[variableFieldsKey][item[regulation['labelCode']]])
                ) {
                    // 调父页面方法展开基本信息
                    this.props.titleAddOrMinus();
                    message.warn({key:this.messageKey, content:item[regulation['labelName']] + "格式不正确"});
                    checkStatus = false;
                    throw new Error(item[regulation['labelName']] + "格式不正确");
                    return checkStatus
                }
            });
        } catch (e) {
            // if (e.message !== "LoopInterrupt") throw e
        }
        //验证跳转链接
        if(this.state.checkedValue&&information.linkurl.length<1){
            message.warning('跳转链接不能为空！');
            checkStatus = false;
            return checkStatus
        }
        // 验证标题图
        let titlePic = information?.titlePic;
        // "/storage/8014CE607614778EE4B265F8592BAD3D"
        let regExp = /^\/storage\/.*?$/;
        if(titlePic && !regExp.test(titlePic)) {
            Modal.confirm({
                title: '当前标题图是外链图片，请下载后手动上传。是否现在下载？',
                content: '',
                onOk: () => {
                    downloadImg(titlePic,"标题图");
                },
                onCancel() {
                },
                okText: "是",
                cancelText: "否",
            });
            checkStatus = false;
            return checkStatus
        }
        return checkStatus
    };

    // 获取焦点
    setFocus = (labelKey) => {
        let node = $Jq("#information_" + labelKey);
        // 先展开表单，然后才能获取到焦点
        this.props.titleAddOrMinus((res)=>{
            if (labelKey && node && node.length) {
                node.focus();
            }
        });
        console.log("node", node);
    };

    selectText(labelKey,sIndex,eIndex){
        let el = $Jq("#information_" + labelKey)[0];
        if(el){
            if(el.setSelectionRange){
                el.setSelectionRange(sIndex,eIndex);
            }else if(el.createTextRange){
                let range = el.createTextRange();
                range.collapse(true);
                range.moveStart("character",sIndex)
                range.moveEnd("character",eIndex);
                range.select();
            }
        }
    }

    // 获取信息
    getInformation(check = true) {
        if (check && !this.checkInformation()) {
            return false
        }
        // let informationData = {};
        const {information, dynamicParams, checkedValue} = this.state;
        // informationData[titleSetting.titleKey] = information.title;//获取标题
        // informationData[informationSetting.labelKey] = information.label;//获取标签
        // return {...informationData,...information}
        // information: {
        //     title: '',//标题
        //         titleStyle: {},
        //     titlePic:'',
        //         label: [],//标签
        //         attach: [],//附件
        // },// 表单固定参数
        // 根据后端数据结构重构
        //加密内容标题
        let wbcontenttitle = this.state.information[informationSetting.variableFieldsKey] ? this.state.information[informationSetting.variableFieldsKey][informationSetting.wbcontenttitleKey] || '' : '';
        let titleStyle = this.state.information[informationSetting.variableFieldsKey] ?
            (this.state.information[informationSetting.variableFieldsKey][informationSetting.titleStyleKey] || '' )
            : '';
        // let newDynamicParams = {
        //     ...dynamicParams,
        //     // 标题样式
        //     titleStyle: information.titleStyle,
        //     // 标签
        //     label: information.label,
        //     ...information[informationSetting.variableFieldsKey],
        //     [informationSetting.wbcontenttitleKey]: base64Encode(removeContentSecurity(wbcontenttitle))
        // };
        let newInformation = {
            ...information,
            wbextends: information.wbextends?JSON.stringify(information.wbextends):information.wbextends,
            linkurl: checkedValue ? information.linkurl : '',
        };
        //根据类型上传标题图
        if(this.titlePicShowType) {
            let titlePicList = [];
            this.titlePicList && this.titlePicList[this.titlePicShowType].forEach(item => {
                if(item.titlePic) {
                    titlePicList.push(item.titlePic)
                }
            })
            newInformation.titlePicList = titlePicList;   //标题图
            newInformation.titlePicShowType = this.titlePicShowType;   //标题图显示类型
        }

        newInformation[informationSetting.variableFieldsKey] = {
            ...newInformation[informationSetting.variableFieldsKey],
            // 当不进行校验时，证明是非提交稿件的操作，不需要加密，否则回填时还需要解密
            [informationSetting.wbcontenttitleKey]: check?base64Encode(removeContentSecurity(wbcontenttitle)):wbcontenttitle,
            [informationSetting.titleStyleKey]: this.toJsonStringify(titleStyle)
        };
        return newInformation
        // return {
        //     information, dynamicParams: newDynamicParams
        // }
    };

    toJsonStringify = (data) => {
        return (data && typeof data === 'object')?JSON.stringify(data):data
    };

    toJsonParse = (data) => {
        return (data && typeof data === 'string')?JSON.parse(data):data
    };

    neWwbextends = (information) => {
        let wbextends = "{}"
        try {
            return wbextends = JSON.parse(information.wbextends)
        }catch (e){
            console.log(e.toString());
            return wbextends = {};
        }
    };

    // 设置默认数据
    setInformation(data = {}) {
        let {information, dynamicParams} = this.state;
        // let informationData = data.variableFields || {};
        // 取稿件标题
        // let title = data.title || informationData.title || "";
        // 回显固定字段
        // for (let a in information) {
        //     if (data[a] || informationData[a]) {
        //         information[a] = data[a] || informationData[a] || "";
        //     }
        // }
        // 回显动态字段
        // for(let a in dynamicParams) {
        //     if(data[a] || informationData[a]) {
        //         dynamicParams[a] = data[a] || informationData[a] || "";
        //     }
        // }
        // dynamicParams = informationData;

        // 动态加载可维护字段variableFields
        let  variableFields=data[informationSetting.variableFieldsKey]||{};
        // 回显隐藏字段
        if (variableFields[informationSetting.wbcontenttitleKey] || variableFields[informationSetting.headlinesKey] || variableFields[informationSetting.ftitleKey] || variableFields[informationSetting.eyebrowKey]) {
            let checkedTitleList = [];
            this.state.titleStatus = true;
            if (variableFields[informationSetting.wbcontenttitleKey]) checkedTitleList.push("内容标题");
            if (variableFields[informationSetting.headlinesKey]) checkedTitleList.push("短标题");
            if (variableFields[informationSetting.ftitleKey]) checkedTitleList.push("副标题");
            if (variableFields[informationSetting.eyebrowKey]) checkedTitleList.push("引题");
            this.state.checkedTitleList = checkedTitleList;
        }
        let titleStyle = data.variableFields ?
            (data.variableFields.titleStyle || {} )
            : {};
        let newData = {
            ...data,
            wbextends: this.neWwbextends(data),
            variableFields: {
                ...data.variableFields,
                titleStyle: this.toJsonParse(titleStyle)
            }
        };

        if(data.linkurl){
            this.state.checkedValue = true
            this.onLinkCheckedCall(false)
        }else{
            this.state.checkedValue = false
            this.onLinkCheckedCall(true)
        }

        //根据展示类型回显标题图
        if (data.titlePicList && data.titlePicList.length && data.titlePicShowType) {
            for (var i = 0; i < this.titlePicList[data.titlePicShowType].length; i++) {
                let item1 = this.titlePicList[data.titlePicShowType][i];
                for (var j = 0; j < data.titlePicList.length; j++) {
                    if (i === j) {
                        item1.titlePic = data.titlePicList[j];
                    }
                }
            }
            this.state.information.titlePic = data.titlePicList[0];
            this.titlePicShowType = data.titlePicShowType;
        } else if(data.titlePicShowType) {
            for (var a = 0; a < this.titlePicList[data.titlePicShowType].length; a++) {
                let item1 = this.titlePicList[data.titlePicShowType][a];
                item1.titlePic = "";
            }
            this.state.information.titlePic = "";
            this.titlePicShowType = data.titlePicShowType;
        }

        this.setState({
            // title,
            information:newData,
            // dynamicParams,
            keywordDefaultChecked: false,
            synopsisDefaultChecked: false,
            isUpDate:true,
        }, () => {
            console.log('this.state.information-----', this.state.information);
            console.log('this.state.dynamicParams', this.state.dynamicParams)
        });
    }

    // 副标题等按钮选中事件
    checkboxOnChange(checkedValues) {
        let notCheckedValues = plainOptions.filter(item=>!checkedValues.includes(item));
        notCheckedValues.forEach(item=>{
            switch (item) {
                case "内容标题":
                    this.state.isUpDate=false;
                    this.setData([informationSetting.wbcontenttitleKey], "",informationSetting.variableFieldsKey);
                    break;
                case "短标题":
                    this.setData(informationSetting.headlinesKey, "",informationSetting.variableFieldsKey);
                    break;
                case "副标题":
                    this.setData(informationSetting.ftitleKey, "",informationSetting.variableFieldsKey);
                    break;
                case "引题":
                    this.setData( informationSetting.eyebrowKey,"",informationSetting.variableFieldsKey);
                    break;
            }
        });
        this.setState({
            checkedTitleList: checkedValues
        })
    }

    //从正文选择
    contentChoose() {
        message.destroy();
        let currentContent = window.ueditor.getContent();
        let imgAll = $Jq(currentContent).find("img").not(".edui-upload-video").not(".edui-faked-video").not(".edui-faked-music").not("img[alias-label='video']");
        this.setState({imgAll});
        if (!(imgAll && imgAll.length)) return message.warning("正文中未找到图片！");
    }

    isOutLink = (url) => {
        if(url) {
            let reg=/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
            return reg.test(url)
        }
        return false
    }

    //视频截取
    videoCaptureContent() {
        message.destroy();
        let currentVideo = document.getElementsByName("ueditor_subcontent")[0].contentWindow.document;
        let videoList = $Jq(currentVideo).find("[alias-label='video']");
        if (!videoList?.length) {
            return message.warning("正文中未找到视频！")
        }
        let videoAll = [];
        for (let j = 0; j < videoList.length; ++j) {
            if($Jq(videoList[j]).attr("duration") >0 && !this.isOutLink($Jq(videoList[j]).attr("source-url"))){
                videoAll.push({
                    duration: $Jq(videoList[j]).attr("duration"),
                    src: $Jq(videoList[j]).attr("video-src"),// 视频内容
                    videoSrc: $Jq(videoList[j]).attr("video-pic"),//视频封面
                    // videoWidth: $Jq(videoList[j]).width(),//视频封面
                    // videoHeight: $Jq(videoList[j]).height() || $Jq(videoList[j])[0].height,//视频封面
                })
            }
        }
        // let num = 0
        // for (let a = 0; a < videoList.length; ++a) {
        //     let b =$Jq(videoList[a]).attr("source-url")
        //     let reg=/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
        //     if(reg.test(b)){
        //         num ++
        //     }
        // }
        if(!videoAll?.length){
           return  message.warning("网络视频无法视频截取！")
        }
        this.setState({videoAll},()=>{
             this.videoCapture.showModal();
        });
    }
    checkInfor(){

        let  getInformation=   this.getInformation()
        console.log(getInformation)
    }
}
